import React, { FC } from 'react'
import {
  HashRouter,
  BrowserRouter,
  BrowserRouterProps,
  HashRouterProps,
} from 'react-router-dom'

type TRouterProps = {
  forceHashRouter: boolean
} & (BrowserRouterProps | HashRouterProps)

export const Router: FC<TRouterProps> = ({ forceHashRouter, ...props }) =>
  forceHashRouter ? <HashRouter {...props} /> : <BrowserRouter {...props} />
